import React from 'react';

export default function (text) {
  return (
    <div className='control-text invoice-remark'>
      {text}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/text.jsx